import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';

/** Typed version of plain `useDispatch` */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useAppDispatch = () => useDispatch<AppDispatch>();
/** Typed version of plain `useSelector` */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
